import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './calculator-step-item.scss';

/**
 * Renders calculator step.
 * @param {string} stepName
 * @param {node[]|node} children
 * @returns {ReactElement}
 */
export function CalculatorStepItem({
  stepName = '',
  children,
  headerClassName = '',
  hideSeparator = false,
  className = '',
  headerTag: Heading = 'h3',
}) {
  return (
    <div className={classNames('calculator-step-item', className)}>
      {!!stepName && (
        <Heading className={classNames('text-gray-darker fw-bold mb-1_25', headerClassName)}>{stepName}</Heading>
      )}
      {children}
      {!hideSeparator && <hr className="separator my-1_5" />}
    </div>
  );
}

CalculatorStepItem.propTypes = {
  stepName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  headerClassName: PropTypes.string,
  hideSeparator: PropTypes.bool,
  className: PropTypes.string,
  headerTag: PropTypes.string,
};
